import { render, staticRenderFns } from "./bankInquiry.vue?vue&type=template&id=7960fa0d&scoped=true"
import script from "./bankInquiry.vue?vue&type=script&lang=js"
export * from "./bankInquiry.vue?vue&type=script&lang=js"
import style0 from "./bankInquiry.vue?vue&type=style&index=0&id=7960fa0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960fa0d",
  null
  
)

export default component.exports